export default __webpack_public_path__ + "static/media/Group 1.a50fa2fc.svg";